import type { ResourceConfig } from "../types";

export const orderConfig = {
  displayName: "订单",
  category: "order",
  permissions: {
    "read:all": {
      label: "查看所有订单",
      description: "可以查看系统中所有订单",
    },
    "write:all": {
      label: "编辑所有订单",
      description: "可以创建和编辑所有订单",
    },
    "read:assigned": {
      label: "查看自己相关的订单",
      description: "只能查看自己成交或参与归因的订单",
    },
    "write:assigned": {
      label: "编辑自己相关的订单",
      description: "只能编辑自己成交或参与归因的订单",
    },
  },
  scopeStrategy: "byOrderCloserOrAttribution",
} satisfies ResourceConfig;
